import { Button } from '@/ui/design-system/components/ui/button';
import { forwardRef } from 'react';
import { withMixpanelClick } from 'utils/app';

const INTENT_TO_VARIANT = {
    primary: 'default',
    secondary: 'outline',
};

const CleanButton = forwardRef(function CleanButton(
    { mixpanelContext, fetching, intent, variant, ...props },
    ref,
) {
    return (
        <Button
            ref={ref}
            loading={fetching}
            variant={variant || INTENT_TO_VARIANT[intent] || 'default'}
            {...props}
        />
    );
});

export default withMixpanelClick(CleanButton, 'Button');
